import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { UserEntity } from '../models/user';
import { UserResponse } from '../lib-api/services/User';

export type UserAuthStoreState = {
  loading: boolean;
  accessToken: string | null;
  idHint: string | null;
  user: UserEntity | null;
};

export type UserStoreState = {
  loading: boolean;
  accessToken?: string;
  idHint?: string;
  user?: UserEntity;
};

const initialState: UserStoreState = {
  loading: false,
  accessToken: undefined,
  idHint: undefined,
  user: undefined,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    getUserStart: (state) => {
      state.loading = true;
    },
    getUserSuccess: (state, action: PayloadAction<UserResponse>) => {
      state.loading = false;
      state.accessToken = action.payload.accessToken;
      state.idHint = action.payload.idHint;
      state.user = action.payload.user;
    },
    getUserFailure: (state) => {
      state.loading = false;
    },
  },
});

export const { getUserStart, getUserSuccess, getUserFailure } = userSlice.actions;
